import React, { useContext, useEffect, useState } from "react";
import * as BiIcons from "react-icons/bi";
import { AppContext } from "../Contexts/AppContext";

const SearchRecord = ({ search, setSearch, label }) => {
  const context = useContext(AppContext);
  const [currentText, setCurrentText] = useState("");
  const [currentColor, setCurrentColor] = useState("");

  useEffect(() => {
    setCurrentText(
      context.isLight
        ? context.currentTheme["commerce"].text
        : context.currentTheme["commerce"].dark_text
    );
    setCurrentColor(
      context.isLight
        ? context.currentTheme["commerce"].dark_dropdown
        : context.currentTheme["commerce"].dropdown
    );
  }, [context]);

  return (
    <div
      title="Search by category"
      className={`crud-search-container relative mb-2 ml-5 mt-0 flex w-44 items-center justify-center border-b-[1px] py-1 before:absolute before:left-0 before:bottom-[-1px] before:h-[2px] before:w-0 before:rounded-3xl 
      ${context.isLight ? "before:bg-purple-300" : "before:bg-purple-700"}
      ${context.isLight ? "after:bg-purple-300" : "after:bg-purple-700"}
      before:transition-all before:duration-300 after:absolute after:bottom-[-1px] after:right-0 after:h-[2px] after:w-0 after:rounded-3xl after:transition-all after:duration-300`}
      style={{ borderColor: currentColor, color: currentText }}
    >
      <div className="flex items-center justify-center transition-all duration-300">
        <label htmlFor="search">
          <BiIcons.BiSearchAlt />
        </label>
      </div>
      <div className="relative ml-2">
        <p
          className="crud-search-input-title absolute left-[1%] z-[-10] translate-y-[-50%] text-lg transition-all duration-300"
          style={{ top: search ? "-30%" : "50%" }}
        >
          {label}
        </p>
        <input
          id="search"
          autoComplete="off"
          className="w-full border-0 bg-transparent p-1 text-lg outline-0"
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
    </div>
  );
};

export default SearchRecord;
